import http from '../../app-utilities/http';
import { endpoints } from './endpoints';

export const resetPassword = (username) => {
  const payloadData = {
    ResetPassword_Request: {
      Party: {
        Username: username,
        PartyType: 'GEKO',
      },
    },
  };

  return http.post(endpoints.RESET_PASSWORD, payloadData);
};
